import React from "react";
import { motion } from "framer-motion";
import "./InstaMarquee.css";

const posts = [
    {
        img: "https://images.pexels.com/photos/6526235/pexels-photo-6526235.jpeg?auto=compress&cs=tinysrgb&w=900",
        user: "furniturelover"
    },
    {
        img: "https://images.pexels.com/photos/5749827/pexels-photo-5749827.jpeg?auto=compress&cs=tinysrgb&w=900",
        user: "thisisaccount"
    },
    {
        img: "https://images.pexels.com/photos/6626314/pexels-photo-6626314.jpeg?auto=compress&cs=tinysrgb&w=900",
        user: "toddlynm"
    },
    {
        img: "https://images.pexels.com/photos/16722871/pexels-photo-16722871.jpeg?auto=compress&cs=tinysrgb&w=900",
        user: "iamwealthy"
    }
];

// ⭐⭐⭐ Triple duplication = seamless infinite loop
const marqueePosts = [...posts, ...posts, ...posts];

export default function InstaMarquee() {
    return (
        <section className="insta-section">
            <h2 className="insta-title">We're on Gram</h2>

            <div className="insta-marquee-wrapper">
                <motion.div
                    className="insta-marquee-track"
                    animate={{ x: ["0%", "-33.333%"] }} // ⭐ move only 1/3 because 3 copies
                    transition={{
                        duration: 25,
                        ease: "linear",
                        repeat: Infinity
                    }}
                >
                    {marqueePosts.map((item, i) => (
                        <div className="insta-card" key={i}>
                            <img src={item.img} className="insta-img" alt="" />
                            <div className="insta-card-footer">
                                <div className="insta-user">
                                    <div className="insta-user-icon" />
                                    {item.user}
                                </div>
                                <span className="insta-ig-icon">📷</span>
                            </div>
                        </div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
